import React from "react";
const Loading = () => (
  <div className="d-flex justify-content-center align-items-center" style={{ height: "150px" }}>
    <div className="spinner-border text-dark-purple" role="status"></div>
  </div>
);
export default Loading;
